
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/cart",
      function () {
        return require("private-next-pages/india/cart.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india/cart"])
      });
    }
  